export function normalizeWeight(value: string) {
  if (!value) {
    return value;
  }

  const normalizedWeight = value.replace(/[^\d.]/g, '');
  return normalizedWeight.slice(0, 6);
}
